import {
  AccountingConnection,
  AccountingConnectionSyncState,
  ListAccountingConnectionsFilterParameterStatusEq
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether a QuickBooks connection is usable — connected AND synced, so its
 * reference data (customers, items) actually reflects the QuickBooks company.
 * The v3 replacement for v1's `isQuickbooksServiceActive`; same predicate the
 * invoice/payable QuickBooks gate uses (see `QuickbooksWrapper`).
 */
export const selectorIsQuickbooksConnectionSynced = (
  connection?: AccountingConnection
): boolean =>
  connection?.status ===
    ListAccountingConnectionsFilterParameterStatusEq.CONNECTED &&
  connection?.syncState === AccountingConnectionSyncState.SYNCED;
